// extracted by css-extract-rspack-plugin
export default {"input":"TextInput-module__input___DrBYS","error":"TextInput-module__error___N6V_A"};